import React from "react";
import "./ExecutiveCommittee.css";

const members = [
  { sr: "१", name: "श्री. मकरंद जगळे बुरांडे", designation: "अध्यक्ष" },
  { sr: "२", name: "श्री.शरद दिगंबर कुलकर्णी", designation: "उपाध्यक्ष" },
  { sr: "३", name: "श्री.महेश भिमराव पाटील", designation: "सचिव" },
  { sr: "४", name: "श्री.ओंकार मकरंद बुरांडे", designation: "खजिनदार" },
  { sr: "५", name: "श्री.विजय शंकरराव घाटगे", designation: "सदस्य" },
  { sr: "६", name: "श्री.प्रसाद मुरलीधर कुलकर्णी", designation: "सदस्य" },
  { sr: "७", name: "श्री.संग्राम शिवाजी घाटगे", designation: "सदस्य" },
  { sr: "८", name: "श्री.अविनाश आनंदराव चरनकर", designation: "सदस्य" },
  { sr: "९", name: "श्री.रविंद्र मुरलीधर कुलकर्णी", designation: "सदस्य" },
  { sr: "१०", name: "श्री.जयवंत जगळे बुरांडे", designation: "सदस्य" },
  { sr: "११", name: "श्री.नवरंग प्रभाकर कुलकर्णी", designation: "सदस्य" },
  { sr: "१२", name: "श्री.ओंकार अनिल देसाई", designation: "सदस्य" },
  { sr: "१३", name: "कु. माधवी विनायक कुलकर्णी", designation: "सदस्य" },
];

export default function SanchalakMandal() {
  return (
    <div className="container">
      <div className="card">
        <h1 className="heading">“ कार्यकारिणी”</h1>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>अ. क्र.</th>
                <th>नाव</th>
                <th>पद</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.sr}>
                  <td>{member.sr}</td>
                  <td>{member.name}</td>
                  <td className="designation">{member.designation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
